export default __webpack_public_path__ + "media/happy_img.e442b14f.png";